import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const DivCheckbox = styled.div`
  width: 90%;
  height: 70px;
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
`;

export const StyledGridButton = styled(Grid)`
  margin-top: 24px;
  margin-bottom: 16px;
`;
